/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _reactRouter = require('react-router');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItem = function MenuItem(props) {
  var pathObj = props.pathObj,
      menuStatus = props.menuStatus;

  return (0, _jsx3.default)('div', {
    className: menuStatus === pathObj.index ? "active-menu" : null,
    onClick: props.handleRoute.bind(undefined, pathObj.link)
  }, void 0, menuStatus === pathObj.index ? (0, _jsx3.default)('img', {
    src: pathObj.img.s,
    alt: ''
  }) : (0, _jsx3.default)('img', {
    src: pathObj.img.n,
    alt: ''
  }), (0, _jsx3.default)('p', {}, void 0, pathObj.name));
};

var Menu = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props, connect) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, connect));

    var pathArr = [];
    _this.props.pathObj.forEach(function (el) {
      pathArr.push(el.matchpath);
    });
    _this.state = {
      menuStatus: 1,
      pathArr: pathArr
    };
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var location = this.props.location;

      this.matchMenu(location.pathname);
    }
  }, {
    key: 'handleRoute',
    value: function handleRoute(path) {
      this.props.router.push({
        pathname: '' + path
      });
      this.matchMenu(path);
    }
  }, {
    key: 'matchMenu',
    value: function matchMenu(path) {
      var _this2 = this;

      var pathArr = this.state.pathArr;
      pathArr.forEach(function (el, i) {
        if (path.indexOf(el) != -1) {
          _this2.setState({
            menuStatus: i + 1
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var pathObj = this.props.pathObj;

      return (0, _jsx3.default)('div', {
        className: 'cp-layout-menu'
      }, void 0, pathObj.map(function (el, i) {
        (0, _assign2.default)(el, { index: i + 1 });
        return (0, _jsx3.default)(MenuItem, {
          pathObj: el,
          handleRoute: _this3.handleRoute.bind(_this3),
          menuStatus: _this3.state.menuStatus
        }, el.index);
      }));
    }
  }]);
  return Menu;
}(_react.Component);

exports.default = (0, _reactRouter.withRouter)(Menu);

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/index.jsx
// module id = 644
// module chunks = 0